import React from 'react';
import styled from 'styled-components';

import { CoinPack } from '../../lib/coinPacks';
import { useCoinContext } from '../../contexts/CoinContext';
import { useEditEventContext } from '../../contexts/EditEventContext';

declare const ELK_COINS_ENABLED: boolean;

const MenuItem = ({ coinPack }: { coinPack: CoinPack }) => {
  const coinContext = useCoinContext();
  const editEventContext = useEditEventContext();

  const onClick = () => {
    editEventContext.storeEvent();
    if (ELK_COINS_ENABLED) {
      coinContext.startPurchase(coinPack.priceId);
    }
  }

  if (coinPack.best) {
    return <BestItem onClick={onClick}>
      <BestContainer>
        <Best>Best Value</Best>
      </BestContainer>
      <Labels>
        <Label>{coinPack.coinAmount} Coin Pack</Label>
        <Label $color="#F4B43E">${coinPack.priceUSD}</Label>
      </Labels>
    </BestItem>;
  } else {
    return <Item onClick={onClick}>
      <Labels>
        <Label>{coinPack.coinAmount} Coin Pack</Label>
        <Label>${coinPack.priceUSD}</Label>
      </Labels>
    </Item>;
  }
};

const Item = styled.div`
  background-color: #EFEFEF;
  border: 2px solid #CDCDCD;
  border-radius: 15px;
  margin: 10px 0;
  padding-top: 25px;
  cursor: pointer;
`;

const BestItem = styled(Item)`
  border-color: #F4B43E;
  padding-top: 0;
  flex-direction: column;
`;

const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 25px 25px;
`;

const Label = styled.div<{ $color?: string }>`
  color: ${({ $color = '#000' }) => $color};
  font-size: 20px;
  font-weight: 300;
`;

const BestContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  height: 25px;
`;

const Best = styled.div`
  background-color: #F4B43E;
  color: #FFF;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 15px;
  font-size: 13px;
  height: 17px;
  padding: 1px 10px;
`;

export default MenuItem;
